import {
  CREDIT_PRICE_PER_EMAIL_CENTS,
  CREDIT_TOP_UP_LIMITS,
  emailsForCents,
} from '@laplace/contracts'
import type { CreditBalanceSummary } from '@laplace/contracts'

export function formatUsdCents(cents: number, lang: string): string {
  return new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: 'USD',
  }).format(cents / 100)
}

/** "Oct 24" in the viewer's language; null when there is no forecast. */
export function formatRunOutDate(
  runOutAt: string | null,
  lang: string,
): string | null {
  if (!runOutAt) return null
  return new Intl.DateTimeFormat(lang, {
    month: 'short',
    day: 'numeric',
  }).format(new Date(runOutAt))
}

export type BalanceBannerState = 'none' | 'low' | 'depleted'

/** The workspace banner: only when the balance needs the customer's action. */
export function balanceBannerState(
  balance: CreditBalanceSummary | null | undefined,
): BalanceBannerState {
  if (!balance) return 'none'
  if (balance.status === 'depleted') return 'depleted'
  if (balance.status === 'low') return 'low'
  return 'none'
}

export const TOP_UP_PRESETS_USD = [50, 100, 150, 500] as const

/** A whole USD amount within the top-up limits, or null. */
export function parseTopUpAmount(raw: string): number | null {
  const trimmed = raw.trim()
  if (!/^\d+$/.test(trimmed)) return null
  const amount = Number(trimmed)
  return amount >= CREDIT_TOP_UP_LIMITS.minUsd &&
    amount <= CREDIT_TOP_UP_LIMITS.maxUsd
    ? amount
    : null
}

export function emailsForUsd(amountUsd: number): number {
  return emailsForCents(amountUsd * 100)
}

export { CREDIT_PRICE_PER_EMAIL_CENTS }
